import { BillingState } from 'src/types/redux';
import { BillingActionType, FETCH_BILLING_FAILURE, FETCH_BILLING_REQUEST, FETCH_BILLING_SUCCESS } from '../types/billingType';

const initialState: BillingState = {
  error: '',
  loading: false,
  billingData: [],
  billingPagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
};

export const billingReducer = (
  state = initialState,
  action: BillingActionType
): BillingState => {
  switch (action?.type) {
    case FETCH_BILLING_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case FETCH_BILLING_SUCCESS:
      return {
        ...state,
        loading: false,
        billingData: action?.payload?.data,
        billingPagination: action?.payload?.pagination
      };
    case FETCH_BILLING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action?.payload,
      };
    default:
      return state;
  }
};
